import { Box, Image, SimpleGrid, Text } from "@chakra-ui/react";
import React, { useRef, useState } from "react";
// import emailjs from "@emailjs/browser";
// import "./Contact.css";
import linkedin from "../../Images/linkedin.png";
import EM from "../../Images/email.png";
import github from "../../Images/github.png";
import PH from "../../Images/phone.png";
import styles from "./Contact.module.css";
import bg1 from "../../Images/coding-kira.gif";

function submitForm(e) {
  e.preventDefault();
  const scriptURL =
    "";
  const form = document.forms["submit-to-google-sheet"];
  const msg = document.getElementById("msg");
  fetch(scriptURL, { method: "POST", body: new FormData(form) })
    .then((response) => {
      msg.innerHTML = "Be patient, I will connect with you shortly....!";
      alert("Thank you for contact");
      setTimeout(function () {
        msg.innerHTML = "";
      }, 5000);
      form.reset();
    })
    .catch((error) => console.error("Error!", error.message));
}

function Contact() {
  return (
    <div
      className={styles.contact_component__space}
      id="Contact"
      name="contact"
    >
      <div className={styles.row}>
        <div className={styles.col__2}>
          <div className={styles.contact__box}>
            <div className={styles.contact__meta}>
              <h1 className={styles.hire__text}>Contact Me...</h1>
              <p className={styles.hire__text_white}>
                I am available for work. Connect with me via phone:
              </p>
              <p className={styles.hire__text_white}>
                <strong>+91 9766580903</strong> or email{" "}
                <strong>shahnajrin@gmail.com</strong>
              </p>
            </div>
            <div className={styles.input__box}>
              <form name="submit-to-google-sheet" onSubmit={submitForm}>
                <input
                  type="text"
                  name="Name"
                  placeholder="Enter Your Name"
                  required
                />
                <input
                  type="email"
                  name="Email"
                  placeholder="Enter Your Email"
                  required
                />
                <div className={styles.col - 6}>
                  <textarea
                    name="Message"
                    rows="6"
                    fixed
                    placeholder="Enter Your Message"
                  ></textarea>
                </div>
                <button className={styles.btn_contact_pointer} type="submit">
                  Submit
                </button>
              </form>
              <span id="msg"></span>
            </div>
          </div>
        </div>
        <div className={styles.col__2}>
          <div className={styles.contact__img}>
            <img src={bg1} alt="" />
          </div>
          <div class={styles.socialicons}>
            <a target="_blank" href="https://www.linkedin.com/in/najrin-shah/">
              <img src={linkedin} alt="li" />
            </a>
            <a target="_blank" href="https://github.com/snaaz123">
              <img src={github} alt="gi" />
            </a>
            <a target="_blank" href="mailto:shahnajrin@gmail.co">
              <img src={EM} alt="EM" />
            </a>
            <a target="_blank" href="tel:+919766580903">
              <img src={PH} alt="li" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;

